
  <div [class]="isMobile ? 'mobile-settings d-lg-none' : 'header-dropdown-menu settings-menu dropdown-menu'">
    <div [class]="isMobile ? 'settings-menu' : ''">
      <ul class="dropdown-list options-wrp">
        <!-- <li class="dropdown-menu-item contrast ">
                <span class="title">{{ "header.contrast" | translate }}</span>
                <div class="options-wrp">
                  <span>{{'header.highContract' | translate}}</span>
                  <label class="radio-toggler contrast-toggler" (click)="switchThemes($event)">
                    <input id="customSwitch1" type="checkbox" [class.checked]="isContrast" />
                    <span class="circle"></span>
                    <span class="switch-bg"></span>
                  </label>
                </div>
              </li>   -->
              <li class="dropdown-menu-item font-resize">
                <span class="title">{{ "header.fontSize" | translate }}</span>
                <ul class="options-wrp">
                  <li class="font-option large-font" (click)="resizeFont('large-font')"
                    [class.active]="fontSelected === 'large-font'">
                    <button>A</button>
                  </li>
                  <li class="font-option medium-font" (click)="resizeFont('medium-font')"
                    [class.active]="fontSelected === 'medium-font'">
                    <button>A</button>
                  </li>
                  <li class="font-option small-font" (click)="resizeFont('small-font')"
                    [class.active]="fontSelected === 'small-font'">
                    <button>A</button>
                  </li>
                </ul>
              </li>
            </ul>
    </div>
</div>      